import { TableCell, TableRow } from "@mui/material";
import { capitalCase } from "change-case";
import PaginationButtons from "src/components/pagination";
import ParseDate from "src/components/parse-date";
import { BodyRow, ReportTable } from "../components";
import useReport from "../hooks/useReport";
import moment from "moment";
import Filter from "./components/filterCard";
import useFilter from "../hooks/use-filter";
import Export from "../export";
import swiftParseDate from "src/utils/swift-parse-date";
import useFilterPayout from "../hooks/use-filter-payout";

const headers = [
  "No",
  "Date",
  "SIP Amount",
  "Account ID",
  "Referrer",
  "Years",
  "Potential Fund",
  "Net Fund",
  "Status",
];

const SIP = ({ title, heading }) => {
  const methods = useFilterPayout();
  const filter = methods.watch();
  const { report, getReport, rowStart, ...rest } = useReport("sip", {
    title,
    heading,
    filter,
  });
  const onFilter = methods.handleSubmit(async (inputData) => {
    await getReport(1, inputData);
  });

  const isEmpty = !Boolean(report?.length);
  const dateAndtime = (dates) => {
    const date = moment(dates);
    const datePlus365 = date.add(365, "days");
    const formattedDate = datePlus365.format("DD/MM/YYYY");
    return <div>{formattedDate}</div>;
  };
  const calculateDaysLeft = (date) => {
    const daysLeft = 365 - date;
    return <>{daysLeft}</>;
  };

  return (
    <>
      <Export methods={methods} type={"sip"} heading={heading} />

      <Filter methods={methods} onFilter={onFilter} getReport={getReport} />
      <ReportTable headers={headers} isEmpty={isEmpty}>
        {report?.map((row, i) => (
          <BodyRow key={row.id}>
            <TableCell component="th" scope="row">
              {i + rowStart}
            </TableCell>

            <TableCell>{swiftParseDate(row?.created_at)}</TableCell>
            <TableCell>{row?.sip_amount}</TableCell>
            <TableCell>{row?.user?.username}</TableCell>
            <TableCell>{row?.sponsor}</TableCell>

            <TableCell>{capitalCase(row?.years)}</TableCell>
            <TableCell>{row?.potential_fund}</TableCell>
            <TableCell>{row.total_amount}</TableCell>
            <TableCell>{row?.status}</TableCell>
          </BodyRow>
        ))}
      </ReportTable>
      <PaginationButtons {...rest} />
    </>
  );
};

export default SIP;
